import { render } from "./SearchFilters.vue?vue&type=template&id=308f1c6b&scoped=true"
import script from "./SearchFilters.vue?vue&type=script&lang=js"
export * from "./SearchFilters.vue?vue&type=script&lang=js"

import "./SearchFilters.vue?vue&type=style&index=0&id=308f1c6b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-308f1c6b"

export default script